import { locale } from 'svelte-i18n';
import { browser } from '$app/environment';

const supportedLocales = ['en', 'es', 'fr', 'de', 'pt', 'it', 'ru', 'zh', 'ja', 'ko'];

export function setupI18n(pathname = '') {
  if (!browser) return;
  
  // Check if URL contains language code
  const urlLang = pathname.split('/')[1];
  if (supportedLocales.includes(urlLang)) {
    locale.set(urlLang);
    return;
  }
  
  // Check localStorage
  const stored = localStorage.getItem('preferred-language');
  if (stored && supportedLocales.includes(stored)) {
    locale.set(stored);
    return;
  }
  
  // Use browser language
  const browserLang = navigator.language.split('-')[0];
  if (supportedLocales.includes(browserLang)) {
    locale.set(browserLang);
  } else {
    locale.set('en'); // fallback to English
  }
}

export function getLocalizedPath(path, lang) {
  // Remove existing language prefix if any
  const cleanPath = path.replace(/^\/[a-z]{2}(\/|$)/, '/');
  
  // Add new language prefix (except for English)
  if (lang === 'en') {
    return cleanPath === '/' ? '/' : cleanPath;
  }
  
  return `/${lang}${cleanPath === '/' ? '' : cleanPath}`;
}

export { supportedLocales };
